// 里の店（米問屋・万屋）の1画面：上の1/3に店の中の背景と看板娘（胸から上）・吹き出し、その上に戻る・題・所持を重ね、下に商品。
// セリフは帯の下端のRPG風の枠（名札つき）。看板娘を押すと話す。中身は ui/komedoiya.ts・ui/yorozuya.ts が .shp-say・.shp-wallet・.shp-panel に描く
import { go } from '../router';
import { esc } from './dom';
import { icon } from './icons';

export interface ShopScene {
  say(text: string, face?: string): void;
  wallet(html: string): void;
  panel: HTMLElement;
}

export function mountShopScene(el: HTMLElement, kind: 'komedoiya' | 'yorozuya', title: string, chara: { src: string; name: string }, onPoke: () => void): ShopScene {
  el.innerHTML = `<div class="page fill shp-page"><section class="shp-scene shp-${kind}">
    <header class="shp-head">
      <button class="icon-btn" type="button" data-shp="back" aria-label="里へ戻る">${icon('left')}</button>
      <h1 class="shp-title">${esc(title)}</h1>
      <div class="shp-wallet"></div>
    </header>
    <div class="shp-stage"><div class="shp-bg" aria-hidden="true"></div><button class="shp-chara-btn" type="button" aria-label="${esc(chara.name)}に話しかける"><img class="shp-chara" src="${chara.src}" alt="" decoding="async"></button>
      <div class="shp-msg"><span class="shp-name">${esc(chara.name)}</span><p class="shp-say" aria-live="polite"></p></div></div>
    <div class="shp-panel"></div>
  </section></div>`;
  el.querySelector('[data-shp="back"]')!.addEventListener('click', () => go('village'));
  el.querySelector('.shp-chara-btn')!.addEventListener('click', onPoke);
  const q = <T extends HTMLElement>(s: string) => el.querySelector<T>(s)!;
  // セリフは1文字ずつ出す（動きを減らす設定なら一度に）
  let timer = 0;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  return {
    say: (text, face = 'smile') => {
      const p = q('.shp-say');
      q('.shp-chara').dataset.face = face;
      clearInterval(timer);
      if (still) return void (p.textContent = text);
      let i = 0;
      p.textContent = '';
      timer = window.setInterval(() => {
        p.textContent = text.slice(0, ++i);
        if (i >= text.length || !p.isConnected) clearInterval(timer);
      }, 35);
    },
    wallet: (html) => (q('.shp-wallet').innerHTML = html),
    panel: q('.shp-panel'),
  };
}
